import { render, staticRenderFns } from "./KVideoPlayer.vue?vue&type=template&id=34c2f83a&scoped=true&"
import script from "./KVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./KVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./KVideoPlayer.vue?vue&type=style&index=0&id=34c2f83a&scoped=true&lang=css&"
import style1 from "./KVideoPlayer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2f83a",
  null
  
)

export default component.exports